export const USER_FETCHED = 'USER_FETCH';
